import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { FileSpreadsheet, FileText, FileDown } from "lucide-react";
import { API } from "@/context/AuthContext";

const FORMATS = [
  { fmt: "csv", label: "CSV", icon: FileDown },
  { fmt: "xlsx", label: "Excel", icon: FileSpreadsheet },
  { fmt: "pdf", label: "PDF", icon: FileText },
];

export const ExportButtons = ({ report, params, endpoint, formats, extra = [] }) => {
  const [busy, setBusy] = useState(null);

  const download = async (fmt) => {
    setBusy(fmt);
    try {
      const qs = new URLSearchParams({ format: fmt, ...(params || {}) });
      const res = await fetch(`${API}${endpoint || `/export/${report}`}?${qs.toString()}`, { credentials: "include" });
      if (!res.ok) throw new Error("export failed");
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${report}-${new Date().toISOString().slice(0, 10)}.${fmt.split("_")[0]}`;
      a.click();
      URL.revokeObjectURL(url);
      toast.success(`${fmt.split("_")[0].toUpperCase()} export downloaded`);
    } catch (e) {
      toast.error("Export failed");
    } finally {
      setBusy(null);
    }
  };

  return (
    <div className="flex gap-2">
      {[...FORMATS.filter((f) => !formats || formats.includes(f.fmt)), ...extra.map((e) => ({ icon: FileSpreadsheet, ...e }))].map(({ fmt, label, icon: Icon, title }) => (
        <Button
          key={fmt}
          variant="outline"
          size="sm"
          title={title}
          data-testid={`export-${fmt}-button`}
          onClick={() => download(fmt)}
          disabled={busy === fmt}
          className="border-slate-300 text-slate-700 hover:bg-slate-50"
        >
          <Icon className="h-4 w-4 mr-1.5" />
          {busy === fmt ? "..." : label}
        </Button>
      ))}
    </div>
  );
};
